import http from 'helpers/http';

import type { IImageConnected, ImageType } from 'models/Image';

export const serviceImage = {
  getImage: (id: string) => http.get<{ image: ImageType; connectedImages: IImageConnected[] }>(`/images/${id}`),
};
